import STATES from '@zenbusiness/graphql-commons-states/static/states';

/**
 * Registry of field options
 */
const FIELD_OPTION_REGISTRY = Object.freeze({
  STATES
});

/**
 * Get a field component by type
 * @param {string} options - Field options
 * @returns {Array|null} Array of options or null if not found
 */
const getFieldOptions = (options) => {
  // If options is an array, return it as is
  if (Array.isArray(options)) {
    for (const option of options) {
      option.value = option.value || option.id;
      if (!option.value) {
        console.error(`[FieldOptionRegistry] Invalid option value: ${option.id}`);
        continue;
      }
    }

    return options;
  }

  // If options is a string and in the format {{KEY}}, extract KEY and use it as the type
  const optionKey = options.replace(/^\{\{(.+)\}\}$/, '$1');
  if (!optionKey) {
    console.error(`[FieldOptionRegistry] Invalid field options: ${options}`);
    return null;
  }

  const fieldOptions = FIELD_OPTION_REGISTRY[optionKey];
  if (!fieldOptions) {
    console.warn(`[FieldOptionRegistry] Unknown field options: ${optionKey}`);
    return null;
  }

  return fieldOptions;
};

export { getFieldOptions };
